import "./Services.css";
import { React, useState, useEffect } from 'react';
import axios from "axios";
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import FloatingLabelInput from "../Components/Table_booking/BookingForm/FloatingLabelInput";
import { use } from "react";
import './contactus.css'

export default function ContactUs() {

  const [username, setUsername] = useState('');
  const [number, setNumber] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');


  const handleSubmitEnquiry = async (e) => {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append('name', username);
    formdata.append('mobile', number);
    formdata.append('email', email);
    formdata.append('subject', subject);
    formdata.append('msg', message);
    try {
      const response = await axios.post('https://partywitty.com/master/APIs/Common/submitContact', formdata);
      console.log(response.data);

      if (response.data.status === true) {
        iziToast.success({
          title: 'Success',
          message: response.data.msg || 'Enquiry Submitted successfully!',
          position: 'topCenter',
        });
        setUsername('');
        setNumber('');
        setEmail('');
        setSubject('');
        setMessage('');
      }
      else {
        iziToast.error({
          title: 'Error',
          message: 'Enquiry submission failed.',
          position: 'topCenter',
        });
      }
    }
    catch (error) {

      iziToast.error({
        title: 'Error',
        message: 'Error Submitting enquiry.',
        position: 'topCenter',
      });
    }
  };



  return (
    <div className="aboutusPage">
      <section className="about--banner">
        <div className="main--box">
          <div className="title--name">
            <h3>Contact us</h3>
          </div>
        </div>

      </section>

      <section className="main--feacture">
        <div className="contact-us-page-section">

          <div className="">
            <div className="">
              <div className="">
                <form onSubmit={handleSubmitEnquiry} className="contact-us-form--box">

                  <FloatingLabelInput
                    type="text"
                    placeholder="Enter Name"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    label="Enter Name"
                    required
                  />




                  <FloatingLabelInput
                    type="number"
                    placeholder="Enter Mobile Number"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    label="Enter Mobile Number"
                    required
                  />



                  <FloatingLabelInput
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    label="Enter Email"
                    required
                  />


                  <FloatingLabelInput
                    type="text"
                    placeholder="Enter Subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    label="Enter Subject"
                  />



                  <FloatingLabelInput
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    label="Help us know what went wrong?"
                  />


                  <div className="contact-us-form--button">
                    <button type="submit" className="">
                      Send Message
                    </button>
                  </div>
                </form>

                <div style={{ color: 'black' }} >
                  <div>
                    <b>Phone No: </b> <a href='tel:+918299619469'> +91 8299619469</a>
                  </div>
                  <div>
                    <b>Email ID: </b> <a href='mailto:sayhello@partywitty.com'>sayhello@partywitty.com</a>
                  </div>
                  <div>
                    <b>Registered Address:</b>
                    <p>AMIRAG HOSPITALITY PVT. LTD
                      <br />
                      E-153,UPPER GF, LEFT SIDE VISHKARMA COLONY
                      <br />
                      DELHI, India - 110044
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
